import { DVMToolSelectedOption, DVMToolSelectionType } from '../services/ppv.api'
import { IDropdownOption } from './dropdown-option.interface'

export class DvmFeedbackRow {
   options: IDropdownOption[]
   selectedItems: IDropdownOption[]
   textareaValue: string
   dropdowns: number
   heading: string
   subheadings: string[]

   constructor() {}

   init(jsonContent: any): DvmFeedbackRow {
      this.dropdowns = jsonContent['dropdowns']
      this.heading = jsonContent['heading']
      this.subheadings = jsonContent['subheadings']
      this.selectedItems = new Array(this.dropdowns).fill(null)
      return this
   }

   loadInputData(dvmId: number, textareaValue: string, selectedOptions: DVMToolSelectedOption[], optionType: DVMToolSelectionType) {
      for (var i = 0; i < this.dropdowns; i++) {
         var filteredItems = selectedOptions.filter((x) => x.dvmEngagementId === dvmId && x.dvmToolSelection.dvmToolSelectionTypeID === optionType)
         if (filteredItems != null && filteredItems?.length > 0) {
            this.selectedItems[i] = filteredItems.map((x) => {
               return { id: x.dvmToolSelectionId, name: x.dvmToolSelection.description }
            })[i]
         }
      }
      this.textareaValue = textareaValue
   }
}
